module.exports = __webpack_public_path__ + "static/media/barbuda-20.fb146f68.jpg";